import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericResModel } from 'countable@model';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private static readonly GET_TRACK_NOTIFICATION = environment.apiV2 + '/track-notification';
  private static readonly GET_USER_WEB_SOCKET = environment.apiV2 + '/user-web-socket';
  private static readonly GET_NOTIFICATION_STATUS = environment.apiV2 + '/notification-status';
  private static readonly GET_USER_NOTIFICATION_ENG = environment.apiV2 + '/user-notification-eng';
  private static readonly SAVE_USER_NOTIFICATION = environment.apiV2 + '/user-notification';
  private static readonly REMOVE_ALL_NOTIFICATION = environment.apiV2 + '/all-notification';
  private static readonly SAVE_USER_TRACK_NOTIFICATION = environment.apiV2 + '/user-track-notification';
  private static readonly SAVE_FIRM_DAILY_REQUEST_TIME = environment.apiV2 + '/firm-daily-request-time';
  private static readonly SAVE_USER_WEB_SOCKET_STATUS = environment.apiV2 + '/user-web-socket-status';

  constructor(private http: HttpClient, private toaster: ToastrService) { }

  public getTrackNotification(inList: string): Observable<any> {
    return this.http.get<GenericResModel<any>>(NotificationService.GET_TRACK_NOTIFICATION, {params: {inList: inList}});
  }

  public getUserWebSocket(): Observable<any> {
    return this.http.get<GenericResModel<any>>(NotificationService.GET_USER_WEB_SOCKET);
  }

  public getNotificationStatus(): Observable<any> {
    return this.http.get<GenericResModel<any>>(NotificationService.GET_NOTIFICATION_STATUS);
  }

  public getUserNotificationEng(): Observable<string> {
    return this.http.get<GenericResModel<string>>(NotificationService.GET_USER_NOTIFICATION_ENG).pipe(
      map(res => {
        if (res.status !== 200 && res.status !== 204) {
          res.errors.forEach(err => this.toaster.warning(err));
        }
        return res.data;
      })
    );
  }

  public saveUserNotification(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(NotificationService.SAVE_USER_NOTIFICATION, data);
  }

  public removeAllNotification(data: string): Observable<GenericResModel<boolean>> {
    return this.http.delete<GenericResModel<boolean>>(NotificationService.REMOVE_ALL_NOTIFICATION, {params: {data: data}});
  }

  public saveUserTrackNotification(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(NotificationService.SAVE_USER_TRACK_NOTIFICATION, data);
  }

  public saveFirmDailyRequestTime(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(NotificationService.SAVE_FIRM_DAILY_REQUEST_TIME, data);
  }

  public saveUserWebSocketStatus(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(NotificationService.SAVE_USER_WEB_SOCKET_STATUS, data);
  }
}
